import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    label: "1. Digital Products & License",
    paragraphs: [
      "All products sold by BENZ THE BRAND are digital downloads. Upon purchase you receive a personal, non-transferable, non-exclusive license to use the product for your own personal use only.",
    ],
  },
  {
    label: "2. No Resale or Redistribution",
    paragraphs: [
      "You may NOT resell, redistribute, share, sublicense, copy, republish, or claim ownership of any product or its contents, in whole or in part, in any format, free or paid. All content remains the intellectual property of BENZ THE BRAND. Violations may result in legal action.",
    ],
  },
  {
    label: "3. Personal Use Only",
    paragraphs: [
      "Products may not be used for commercial purposes, teaching materials, templates for resale, or content creation for other brands without written permission.",
    ],
  },
  {
    label: "4. Accuracy",
    paragraphs: [
      'Products are provided "as is." While created with care, no guarantee is made that content is error-free.',
    ],
  },
];

export default function Terms() {
  return <LegalPage title="Terms of Use" updated="2026-07-06" sections={sections} testId="terms-page" />;
}
